import { trustBadges } from '@/mocks/categories';

export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Fresh%20minimalist%20product%20flat%20lay%20with%20beautifully%20arranged%20sneakers%20handbags%20sunglasses%20watches%20and%20beauty%20products%20on%20soft%20mint%20green%20and%20cream%20surface%20airy%20composition%20with%20ample%20negative%20space%20modern%20editorial%20style%20dreamy%20soft%20gradients%20natural%20light%20clean%20aesthetic&width=1800&height=1200&seq=hero-bg-v3&orientation=landscape"
          alt="Kakobuy Spreadsheet resource hub background"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/25"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-6 text-center py-20 md:py-0">
        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-tight tracking-tight">
          The Ultimate Kakobuy
          <br />
          Spreadsheet Resource Hub
        </h1>
        <p className="mt-6 text-base md:text-lg text-background-100/90 max-w-2xl mx-auto leading-relaxed">
          Discover thousands of curated Kakobuy Spreadsheet finds, updated product lists, shopping guides, and expert comparisons — all in one powerful database.
        </p>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#categories"
            className="inline-flex items-center gap-2.5 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            Explore Categories
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2.5 px-8 py-3.5 rounded-full border-2 border-background-50/40 text-background-50 font-semibold text-sm hover:bg-background-50/10 transition-all whitespace-nowrap cursor-pointer"
          >
            Buy It Now
            <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center"></i>
          </a>
        </div>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
          {trustBadges.map((badge) => (
            <span
              key={badge.text}
              className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-background-50/15 backdrop-blur-sm text-background-50 text-xs font-medium"
            >
              <i className={`${badge.icon} w-3.5 h-3.5 flex items-center justify-center`}></i>
              {badge.text}
            </span>
          ))}
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-s-line text-background-50/60 text-2xl"></i>
      </div>
    </section>
  );
}